'use client';

import { Flex, Link, For, Box } from "@chakra-ui/react";
import { LuCircleX } from "react-icons/lu"

export default function ResponsiveMenu({ categories, openedMenu, handleMenuToggle }) {
  const menu = categories.map(cat => {
    return {
      taxName: cat.taxName,
      taxSlug: `/categoria/${cat.taxSlug}`,
      taxWeight: '400'
    };
  });

  return (
    <>
      <Box
        position="fixed"
        top="0"
        left="0"
        backdropFilter="blur(3px)"
        w="100%"
        h="100%"
        zIndex="999999"
        display={openedMenu ? 'block' : 'none'}
      >
      </Box>

      <Box
        position="fixed"
        top="0"
        left={openedMenu ? '0' : '-200%'}
        bgColor="rgba(54, 57, 59, 0.8)"
        w={{base: '100%', md: '50%', xl: '30%' }}
        h="100%"
        zIndex="9999999"
        transition="all .5s ease-in-out"
      >
        <Box h="100%" position="relative">
          <Box position="absolute" top="0" right="0" p="6" fontSize="1.6em" cursor="pointer" onClick={() => handleMenuToggle()}>
            <LuCircleX />
          </Box>

          <Flex flexDirection="column" justifyContent="center" alignItems="end" py="6" h="100%">
            <For each={menu}>
              {item => (
                <Link
                  href={`${item.taxSlug}`}
                  key={item.taxName}
                  title={item.taxName}
                  pr="10"
                  pl={{ base: '12', md: '28' }}
                  py="2"
                  fontWeight={item.taxWeight}
                  fontSize="1.2em"
                  color="white"
                  textTransform="uppercase"
                  _hover={{ color: 'orange.500' }}
                  bgColor={item.color ? item.color : 'transparent'}
                  textAlign="left"
                  display="inline-block"
                  w="100%"
                >
                  {item.taxName}
                </Link>
              )}
            </For>
          </Flex>
        </Box>
      </Box>
    </>
  )
}
